<template>
  <div id="Manager" class="fullheight" style="height: calc(100% - 20px); padding-top: 16px">
    <eco-table
      @load="loadData"
      :data="budget_manager"
      :pageResult="pageResult"
      :selection="true"
      quick-search-props="bpm_definition.NAME_,bpm_definition.DEF_KEY_"
      :show-export="false"
      :show-custom-column="false"
      ref="ecoTable"
    >
      <template v-slot:toolbar>
        <el-button size="small" @click="enableAll(1)">全部启用</el-button>
        <el-button size="small" @click="enableAll(0)" class="marginRight16">全部关闭</el-button>
        <el-button size="small" @click="exportAll" class="marginRight16">导入</el-button>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="bpm_definition.NAME_" label="流程名称" :sortable="true" :sort-by="'bpm_definition.NAME_'" :show-overflow-tooltip="true">
        </eco-table-column>
        <eco-table-column prop="bpm_definition.DEF_KEY_" label="流程key值" :sortable="true" :sort-by="'bpm_definition.DEF_KEY_'" :show-overflow-tooltip="true">
        </eco-table-column>
        <eco-table-column prop="f_status" label="是否启用" :sortable="true" :sort-by="'f_status'" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" @change="enable(scope.row.id, scope.row.flow_key, $event)"> </el-switch>
          </template>
        </eco-table-column>
      </template>
    </eco-table>
    <el-dialog
      width="70%"
      style="height: 500px"
      title="导入数据"
      class="sp-manager__dialog"
      :visible="importShow"
      :close-on-click-modal="false"
      :before-close="beforeCloseimport"
      @dialogclose="beforeCloseimport"
      :destroy-on-close="true"
      append-to-body
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">导入数据</span>
      </div>
      <div style="margin-bottom: 10px">
        <el-button :loading="loading" class="marginLeft10" @click="iExport"> 模板下载 </el-button>
      </div>
      <eip-import-material
        model-name="importList"
        permission="w"
        propConf='[{"name":"prop1"}]'
        accept="xlsx,xls"
        limit="1"
        displayType="table"
        :multiple="false"
        :importsuccess="true"
        :importurl5="importurl"
      >
        <span slot="labeldesc">导入数据</span>
      </eip-import-material>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeCloseimport" type="primary">完 成</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import eipImportMaterial from '@/components/eipControl/EipImportMaterial.vue'
import req from '@/request'

export default {
  components: { eipImportMaterial },
  props: {},
  data() {
    return {
      importShow: false,
      loading: false,
      budget_manager: [],
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      importurl: '/system/flow_config/importXlsx',
      tenantId: '-1',
      model: {},
      isView: true,
      isEdit: false,
      saveMethod: 'POST',
      formConfig: {},
      formList: []
    }
  },
  mounted() {},
  methods: {
    enableAll(status) {
      this.$confirm('是否继续操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {
          this.$http.post('${portal}/system/flow_config/updateStatus?tenantId=' + this.tenantId + '&status=' + status).then(
            (resp) => {
              let response = resp.data
              if (response.state) {
                this.$message.success('流程配置操作成功')
                this.$refs.ecoTable.load()
              } else {
                this.$message.error('流程配置操作失败')
              }
            },
            (error) => {
              reject(error)
            }
          )
        })
        .catch(() => {})
    },
    enable(id, flow_key, status) {
      const param = { id: id, flow_key: flow_key, status: status }
      if (id) {
        this.$http.put('${portal}/system/flow_config?tenantId=' + this.tenantId, param).then(
          (resp) => {
            let response = resp.data
            if (response.state) {
              this.$message.success('流程配置操作成功')
              this.$refs.ecoTable.load()
            } else {
              this.$message.error('流程配置操作失败')
            }
          },
          (error) => {
            reject(error)
          }
        )
      } else {
        this.$http.post('${portal}/system/flow_config?tenantId=' + this.tenantId, param).then(
          (resp) => {
            let response = resp.data
            if (response.state) {
              this.$message.success('流程配置操作成功')
              this.$refs.ecoTable.load()
            } else {
              this.$message.error('流程配置操作失败')
            }
          },
          (error) => {
            reject(error)
          }
        )
      }
    },
    exportAll() {
      this.importShow = true
    },
    beforeCloseimport() {
      this.importShow = false
      this.$refs.ecoTable.load()
    },
    iExport() {
      req.downloadTemp('${portal}/system/flow_config/exportModel')
    },
    loadData(param, cb) {
      const tenantId = sessionStorage.getItem('currentTenantId')
      if (tenantId) {
        this.tenantId = tenantId
      } else {
        this.tenantId = '-1'
      }
      if (param && cb) {
        const obj = {
          param: param,
          cb: cb
        }
        sessionStorage.setItem('flowConfigLoadJSON', JSON.stringify(obj))
      }
      if (!param) {
        const session = JSON.parse(sessionStorage.getItem('flowConfigLoadJSON'))
        param = session.param
        cb = session.cb
      }
      if (this.tenantId) {
        this.$http
          .post('${portal}/system/flow_config/query?tenantId=' + this.tenantId, param)
          .then(
            (resp) => {
              let response = resp.data
              let res = response.rows
              res.forEach((item) => {
                item.f_id = item.id
                item.bpm_definition = {}
                item.bpm_definition.NAME_ = item.flow_name
                item.bpm_definition.DEF_KEY_ = item.flow_key
                item.f_status = item.status
              })
              this.budget_manager = res
              this.pageResult = {
                page: response.page,
                pageSize: response.pageSize,
                total: response.total
              }
            },
            (error) => {
              reject(error)
            }
          )
          .finally(() => cb())
      } else {
        this.budget_manager = []
        this.pageResult = {
          page: 1,
          pageSize: 50,
          total: 0
        }
      }
    },
    afterSaveData() {
      setTimeout(() => {
        this.beforeCloseDialog()
        this.$refs.ecoTable.load()
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped></style>
